import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ThemeList from '../components/Themes/ThemeList'

export default ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={ThemeList} />
  </Switch>
)
